"use strict";

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.number.is-nan");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-float");

/**
 * Valid, non-numeric values for series data
 * @enum
 */
var SeriesDataValue = {
  /**
   * Represent a lack of data (as opposed to zero) within a series
   */
  NO_DATA: 'NO_DATA'
};
/**
 * Return whether or not a value is a valid series data value
 * @param {number|SeriesDataValue} value The value to validate for series data
 * @returns {boolean} True if value is valid for series data; otherwise false.
 */

SeriesDataValue.isValidSeriesDataValue = function isValidSeriesDataValue(value) {
  var numericValue = NaN;

  if (typeof value === 'number') {
    numericValue = Number.parseFloat(value);
  }

  return !Number.isNaN(numericValue) || value === 'NO_DATA';
};

var _default = SeriesDataValue;
exports.default = _default;